export interface TestimonialOutputApiModel {
    id: number;
    internal_id: number;
    id_campaign: number;
    title: string;
    slug: string;
    author: string;
    lead_count: number;
    like_count: number;
    player_count: number;
    published: Date;
    status: string;
    approver: string;
    approved: boolean;
    visible: boolean;
    active: boolean;
    public: boolean;
    internal: boolean;
    author_company?: any;
    author_email?: any;
    author_type?: any;
    job_title?: any;
    consent_details?:any;
    final_approver?: any;
    id_campaign_consent?:any;
    campaign_only?: any;
    spotlight_only?: boolean;
    scheduler_data?: any;
    campaign_ids?:any;
    interview_style?:any;
}

export class TestimonialOutputApiModel {
    constructor(data?: Partial<TestimonialOutputApiModel>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}


